<ziro-fieldset-header [legend]="'tkey;shared.dnWizard.dnDetails.didDetails.header'">
  <ziro-text fieldId="description"></ziro-text>
  <ziro-select fieldId="classOfService"></ziro-select>
  <ziro-select fieldId="routePartition"></ziro-select>
</ziro-fieldset-header>
